import React, { useState, useEffect } from 'react';
import { StyledHeading } from '../../components/Dashboard/styles.js';
import { Table } from 'antd';
import { getFailureDocumentList } from '../../utils/services/dashboardAPI';
import { useCallback } from 'react';
import { withTranslation } from 'react-i18next';
import { FAILED_TEMPLATES_TABLE } from './TranslationValues.js';
const NAMESPACES = 'FAILED_TEMPLATES_TABLE';

const FailedTemplates = ({
  title,
  columns,
  startDate,
  endDate,
  activeTab,
  selectedTeam,
  setChartSectionLoader,
  viewType,
  showTitle = true,
  t,
}) => {
  const [failureDocumentData, setFailureDocumentData] = useState({});
  // This state is used to forcefully update the table when global filters are applied.
  const [tableKey, setTableKey] = useState(`reset-${Date.now()}`); 

  useEffect(() => {
    setTableKey(`reset-${Date.now()}`);
    handleChange(1, {}, {});
  }, [viewType, activeTab, selectedTeam, startDate, endDate]);

  const tableLocale = {
    filterConfirm: t(FAILED_TEMPLATES_TABLE.DROPDOWN_CONFIRM_BUTTON.key, FAILED_TEMPLATES_TABLE.DROPDOWN_CONFIRM_BUTTON.value),
    filterReset: t(FAILED_TEMPLATES_TABLE.DROPDOWN_RESET_BUTTON.key, FAILED_TEMPLATES_TABLE.DROPDOWN_RESET_BUTTON.value),
    emptyText: t(FAILED_TEMPLATES_TABLE.NO_DATA_TEXT.key, FAILED_TEMPLATES_TABLE.NO_DATA_TEXT.value),
  };


  const handleChange = async (pagination, filters, sorter) => {
    const payload = {
      startDate,
      endDate,
      page: 1,
      limit: 7,
    };
    if(pagination.current) {
      payload.page = pagination.current;
    }
    if (sorter.hasOwnProperty('order')) {
      payload.isAscending = sorter.order === 'ascend';
    }
    if (filters.hasOwnProperty('failureReason') && filters.failureReason.length !== 0) {
      payload.failureReason = filters.failureReason[0];
    }
    if(selectedTeam) {
      payload.teamId = selectedTeam;
    }
    try {
      setChartSectionLoader(true);
      const res = await getFailureDocumentList({ env: activeTab, payload: payload });
      setFailureDocumentData(res);
      setChartSectionLoader(false);
    } catch (e) {
      setChartSectionLoader(false);
    }
  };

  const getPaginationStatus = useCallback(() => {
    if (
      failureDocumentData.hasOwnProperty('data') &&
      failureDocumentData?.data?.documentFailureList?.length > 0
    ) {
      return {
        total: failureDocumentData.dataCount,
        size: 'small',
        pageSize: 7,
      };
    }
    return false;
  }, [failureDocumentData]);

  return (
    <>
      {showTitle && 
        <StyledHeading>
          <h2>{title}</h2>
        </StyledHeading>
      }
        <Table
          key={tableKey}
          className="failed-templates-table"
          dataSource={
            failureDocumentData.hasOwnProperty('data')
              ? failureDocumentData?.data?.documentFailureList
              : []
          }
          rowKey={record => record.transactionId}
          columns={columns}
          pagination={getPaginationStatus()}
          onChange={handleChange}
          locale={tableLocale}
        />
    </>
  );
};

export default withTranslation(NAMESPACES)(FailedTemplates);
